export enum DeclarationActionTypes {
  initiate = 'initiate',
  confirm = 'confirm',
  withdraw = 'withdraw',
}
